import { AxiosError } from "axios";
import { ErrorType } from "../types/errorTypes";

export const errorGlobal = (error: AxiosError) => ({
  type: ErrorType.ERROR_SUCCESS,
  payload: {
    error,
  },
});
